import { env } from '$env/dynamic/public';
import { IConfig } from '../interfaces';

const { PUBLIC_NODE_ENV } = env;

export const svelteConfig: IConfig = {
  env: PUBLIC_NODE_ENV,
  // @ts-ignore
  // This variable is Injected by vite compiler
  // Add undefined check for storybook building process (This will be injected with vite only, storybook is compiled by webpack)
  version: typeof SITE_APP_VERSION === 'undefined' ? 1 : SITE_APP_VERSION,
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
  },
  heap: { id: import.meta.env.VITE_HEAP_APP_ID },
  providerUrl: import.meta.env.VITE_PROVIDER_APP_HOST,
  patientUrl: import.meta.env.VITE_PATIENT_APP_HOST,
  oldPatientUrl: import.meta.env.VITE_APP_HOST,
  homeUrl: import.meta.env.VITE_APP_HOST,
  stripe: {
    key: import.meta.env.VITE_STRIPE_PUB_KEY
  },
  googleMap: {
    key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY
  }

};
